var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"searchContainer"}},[_c('div',{staticClass:"searchBar"},[_c('div',{staticClass:"form"},[_c('span',[_c('input',{ref:"search_keyword",attrs:{"type":"text","placeholder":"请输入感兴趣的关键词，试试看~","name":"kewword"},domProps:{"value":_vm.keyword}})]),_vm._v(" "),_c('button',{on:{"click":_vm.searchRes}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33221743","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBar.vue
// module id = null
// module chunks = 